export type ToastMessage = {
  severity: "success" | "info" | "warn" | "error"
  summary: string
  detail?: string
  life?: number
}

export type ToastNotifier = (message: ToastMessage) => void

let notifier: ToastNotifier | null = null

export function setGlobalToastNotifier(handler: ToastNotifier): void {
  notifier = handler
}

export function getGlobalToastNotifier(): ToastNotifier | null {
  return notifier
}

export function notifyToast(message: ToastMessage): void {
  notifier?.(message)
}
